import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";

import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";
import { ResourceItemProps } from "@/features/certifications/module/components/types";

import "./styles.css";

const CHECK_ICON_SIZE = 14;

const ResourceItem = ({
  row,
  isDone = false,
  isDownloading,
  isBusy,
  onDownload,
}: ResourceItemProps) => {
  const { t } = useTranslation();

  return (
    <li className="module-resource flex items-center gap-300">
      <span
        className={`module-file-badge module-file-badge-${row.tone} flex flex-none items-center justify-center`}
        aria-hidden
      >
        {row.format}
      </span>

      <div className="module-resource-text flex flex-col flex-1">
        <span className="certification-heading body-s-medium">{row.title}</span>

        <span className="certification-muted body-xs-regular">{row.meta}</span>
      </div>

      <div className="flex flex-wrap items-center justify-end gap-300">
        {isDone && (
          <span className="module-resource-done flex items-center gap-100 body-s-regular">
            <Check size={CHECK_ICON_SIZE} aria-hidden />

            {t("certification.module.readings.downloaded")}
          </span>
        )}

        <BaseButton
          variant={BUTTON_VARIANTS.TERTIARY}
          size={BUTTON_SIZES.EXTRA_SMALL}
          ariaLabel={t(
            isDone
              ? "certification.module.readings.downloadAgainLabel"
              : "certification.module.resources.downloadLabel",
            { title: row.title },
          )}
          loading={isDownloading}
          disabled={isBusy}
          onClick={() => onDownload(row.id)}
        >
          {isDone
            ? t("certification.module.readings.downloadAgain")
            : t("certification.module.resources.download")}
        </BaseButton>
      </div>
    </li>
  );
};

export default ResourceItem;
